// Chakra imports
import { SimpleGrid, Text, useColorModeValue } from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import React from "react";
import Information from "views/admin/profile/components/Information";

// Assets
export default function GeneralInformation(props) {
  const { ...rest } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );
  return (
    <Card mb={{ base: "0px", "2xl": "20px" }} {...rest}>
      <Text
        color={textColorPrimary}
        fontWeight='bold'
        fontSize='2xl'
        mt='10px'
        mb='4px'>
        General Information
      </Text>
      <Text color={textColorSecondary} fontSize='md' me='26px' mb='40px'>
      The patient is a 20-year-old male with a history of hypertension and diabetes. He presents with a complaint of shortness of breath and chest pain. Upon examination, he is found to have an elevated heart rate and blood pressure...
      </Text>
      <SimpleGrid columns='2' gap='20px'>
        <Information
          boxShadow={cardShadow}
          title='Age'
          value='20 year old'
        />
        <Information
          boxShadow={cardShadow}
          title='Languages'
          value='English, German, Arabic'
        />
        <Information
          boxShadow={cardShadow}
          title='Sex'
          value='Male'
        />
        <Information
          boxShadow={cardShadow}
          title='Weight'
          value='75Kg'
        />
        <Information
          boxShadow={cardShadow}
          title='Phoen number'
          value='0776-69-48-57'
        />
        <Information
          boxShadow={cardShadow}
          title='Height'
          value='1 m 75'
        />
      </SimpleGrid>
    </Card>
  );
}
